import { NavTabsData } from './PC/NavTabs';

export enum LinkHref {
  Home = '/', // 首页
  Domain = '/domain', // 领域
  DomainPublicWelfarePlatform = '/domain/public-welfare-platform', // 公益平台
  DomainVillageDevelopment = '/domain/village-development', // 为村发展
  DomainTechEcosystem = '/domain/tech-ecosystem', // 科技生态
  DomainCarbonNeutrality = '/domain/carbon-neutrality', // 碳中和
  DomainTimeLab = '/domain/time-lab', // 时光实验室
  DomainHealthWelfare = '/domain/health-welfare', // 健康普惠
  DomainDigitalCulture = '/domain/digital-culture', // 数字文化
  DomainDigitalTeach = '/domain/digital-teach', // 数字教育
  OpenPlatform = '/open-platform', // 开放平台
  OpenPlatformTools = '/open-platform#tools', // 数字工具箱
  OpenPlatformDevelop = '/open-platform#develop', // 开发者工具
  OpenPlatformBrand = '/open-platform#brand', // 品牌素材
  Project = 'https://techforgood.qq.com/vcp', // 项目
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ProjectVcp = 'https://techforgood.qq.com/vcp', // 创投计划
  ProjectCarbonXProgram = 'https://carbonxprogram.com', // 碳寻计划
  ProjectTanyuanPlan = 'https://tanyuan.qq.com/plan/2024', // 探元计划
  ProjectElderlytechPartner = '/project/elderlytech-partner',
  ProjectGenerationPlanExplore = '/project/generation-plan', // 生机计划
  Case = '/case', // 案例
  CaseSelected = '/case', // 精选案例
  CaseExpert = '/case#Expert', // 专家观点
  CaseStandard = '/case#Standard', // 行业标准
  CaseActivityS2024 = '/case/activity/s-2024', // S大会
  CaseActivityS2025 = '/case/activity/s-2025', // S大会
  CaseActivityS2026 = '/case/activity/summit', // S大会
  SMakers = '/case/activity/s-makers', // S-Makers
  CaseUpload = '/case/upload',
  Report = '/report',
  DesignAssets = '/design-guidelines', // 品牌规范
  AboutSSV = '/about-us',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  AboutUs = '/about-us',
  Cooperate = '/cooperate', // 生态合作招募
  Account = '/account/personal', // 个人账户中心
  AccountLevelPage = '/account/level-page', // 个人信息概览
  AccountToolbox = '/account/toolbox', // 工具箱
  AccountResource = '/account/resource',
  AI = '/ai',
  AIDesign = '/ai/design',
  AIMemoirs = '/ai/memoirs',

  TeamPreposition = '/team/preposition', // 团队认证
  TeamAuthentication = '/team/authentication', // 团队类型
  TeamDetail = '/team/detail', // 团队详情
  TeamAccount = '/team-account', // 团队账户中心
  TeamAccountOverview = '/team-account/overview', // 团队概览
  TeamAccountMember = '/team-account/member', // 成员信息
  TeamAccountToolbox = '/team-account/toolbox', // 工具箱
  TeamAccountResource = '/team-account/resource', // 领域工具
  TeamAccountStationMessage = '/team-account/stationMessage', // 站内信
  TeamAccountOverviewBase = '/team-account/overview/base', // 概览-基础信息
  TeamAccountOverviewSuper = '/team-account/overview/super', //概览-超级管理员
  TeamAccountOverviewExplain = '/team-account/overview/explain', // 概览-团队权限说明
  TeamAccountToolboxProduct = '/team-account/toolbox/product', // 工具箱-产品权益
  TeamAccountToolboxDigital = '/team-account/toolbox/digital', // 工具箱-数字化服务
  TeamAccountToolboxDeveloper = '/team-account/toolbox/developer', // 工具箱-开发者工具

  // 申领
  OpenPlatformToolApply = '/open-platform/tool-apply',

  EarthquakeWarningPlatform = 'https://open.emergency.qq.com/pc/home',
}
export const menus: NavTabsData = [
  {
    title: '首页',
    href: LinkHref.Home,
  },
  // {
  //   title: '领域',
  //   alias: '/domain',
  //   href: LinkHref.Domain,
  //   subMenus: [
  //     {
  //       title: '公益平台',
  //       href: LinkHref.DomainPublicWelfarePlatform,
  //       groupLabel: '产品驱动',
  //       groupOrder: 1,
  //     },
  //     {
  //       title: '数字教育',
  //       href: LinkHref.DomainDigitalTeach,
  //       groupLabel: '产品驱动',
  //       groupOrder: 1,
  //     },
  //     {
  //       title: '时光实验室',
  //       href: LinkHref.DomainTimeLab,
  //       groupLabel: '产品驱动',
  //       groupOrder: 1,
  //     },
  //     {
  //       title: '科技生态',
  //       href: LinkHref.DomainTechEcosystem,
  //       groupLabel: '创新资助',
  //       groupOrder: 2,
  //     },
  //     {
  //       title: '数字文化',
  //       href: LinkHref.DomainDigitalCulture,
  //       groupLabel: '创新资助',
  //       groupOrder: 2,
  //     },
  //     {
  //       title: '碳中和',
  //       href: LinkHref.DomainCarbonNeutrality,
  //       groupLabel: '创新资助',
  //       groupOrder: 2,
  //     },
  //     {
  //       title: '为村发展',
  //       href: LinkHref.DomainVillageDevelopment,
  //       groupLabel: '在地生长',
  //       groupOrder: 3,
  //     },
  //     {
  //       title: '健康普惠',
  //       href: LinkHref.DomainHealthWelfare,
  //       groupLabel: '在地生长',
  //       groupOrder: 3,
  //     },
  //   ],
  // },
  // {
  //   title: '开放平台',
  //   href: LinkHref.OpenPlatform,
  //   alias: '/open-platform',
  //   onlyOA: true,
  //   // subMenus: [
  //   //   { title: '数字工具箱', href: LinkHref.OpenPlatformTools },
  //   //   { title: '开发者工具', href: LinkHref.OpenPlatformDevelop },
  //   //   { title: '品牌素材', href: LinkHref.OpenPlatformBrand },
  //   // ],
  // },
  // {
  //   title: 'AI 工具箱',
  //   href: LinkHref.AI,
  //   alias: '/ai',
  //   onlyOA: true,
  //   mobileHide: true,
  // },
  // {
  //   title: '项目',
  //   alias: '/project',
  //   subMenus: [
  //     // { title: '创投计划', href: LinkHref.ProjectVcp },
  //     // { title: '碳寻计划', href: LinkHref.ProjectCarbonXProgram },
  //     // { title: '探元计划', href: LinkHref.ProjectTanyuanPlan },
  //     // { title: '银发伙伴', href: LinkHref.ProjectElderlytechPartner },
  //     // { title: '生机计划', href: LinkHref.ProjectGenerationPlanExplore },
  //     {
  //       title: '科学探索奖',
  //       href: '	https://www.xplorerprize.org/#/index',
  //       isBlank: true,
  //     },
  //     { title: '碳寻计划', href: 'https://carbonxprogram.com/', isBlank: true },
  //     {
  //       title: '开放研究计划',
  //       href: 'https://mp.weixin.qq.com/s/KgnxqTAH-LQskxNiwkPeDQ',
  //       isBlank: true,
  //     },
  //     // {
  //     //   title: '工具箱合作',
  //     //   href: 'https://mp.weixin.qq.com/s/j0uBaE3YnuLF41bSGw9qMA',
  //     //   isBlank: true,
  //     // },
  //   ],
  // },
  {
    title: '案例',
    alias: '/case',
    href: LinkHref.Case,
    subMenus: [
      { title: '精选案例', href: LinkHref.CaseSelected },
      { title: '专家观点', href: LinkHref.CaseExpert },
      { title: '行业标准', href: LinkHref.CaseStandard },
    ],
  },
  {
    title: '报告',
    alias: '/report',
    href: LinkHref.Report,
  },
  {
    title: '活动',
    alias: '/case/activity',
    subMenus: [
      { title: 'S大会', href: LinkHref.CaseActivityS2026 },
      { title: 'S-Makers', href: LinkHref.SMakers },
    ],
  },
  {
    title: '关于SSV',
    href: LinkHref.AboutSSV,
    alias: '/about-us',
  },
];

// 竖的菜单配置数据
type MenuListProps = {
  label: string;
  isTitle?: boolean;
  link?: string;
}[][];
export const getMenuList = () => {
  const excludeList = ['案例'];
  const arrars: MenuListProps = [[{ label: '腾讯SSV官网', isTitle: true }]];
  menus.forEach((el) => {
    if (el.subMenus && !excludeList.includes(el.title)) {
      const subMenus = el.subMenus.map((item) => ({
        label: item.title,
        link: item.href ?? item.alias,
      }));
      arrars.push([{ label: el.title, isTitle: true }, ...subMenus]);
      return;
    }
    arrars[0].push({ label: el.title, link: el.href ?? el.alias });
  });
  return arrars;
};
